import React from 'react';
import PropTypes from 'prop-types';
import { Stack, Dialog, DialogType, PrimaryButton, DefaultButton } from '@bingads-webui-react/fabric-control';
import { ReactTemplate } from '@bingads-webui-react/react-template';

const buttonStackTokens = { childrenGap: 5 };
const verticalStackTokens = { childrenGap: 10 };

export const ByPassConfirmationModal = ({
  i18n,
  messageKey,
  onDismiss,
  onConfirm,
}) => (
  <Dialog
    hidden={false}
    dialogContentProps={{
      isMultiline: true,
      onDismiss,
      title: i18n.getString('FAC_GImport_Lightbox_AreYouSure'),
      type: DialogType.close,
      className: 'fac-bypass-popup',
    }}
    minWidth={400}
  >
    <Stack tokens={verticalStackTokens}>
      <Stack.Item className="fac-bypass-line1">{i18n.getString(messageKey)}</Stack.Item>
      <Stack.Item className="fac-bypass-line2">
        <ReactTemplate
          model={{
            cancelButtonText: <b>{i18n.getString('Button_Cancel')}</b>,
          }}
          template={i18n.getString('FAC_GImport_Lightbox_AreYouSure_FooterText')}
        />
      </Stack.Item>
      <Stack horizontal tokens={buttonStackTokens}>
        <PrimaryButton onClick={onConfirm} className="fac-bypass-confirm">
          {i18n.getString('Button_Confirm')}
        </PrimaryButton>
        <DefaultButton onClick={onDismiss} className="fac-bypass-dismiss">
          {i18n.getString('Button_Cancel')}
        </DefaultButton>
      </Stack>
    </Stack>
  </Dialog>
);
ByPassConfirmationModal.propTypes = {
  i18n: PropTypes.shape({
    getString: PropTypes.func.isRequired,
  }).isRequired,
  messageKey: PropTypes.string.isRequired,
  onDismiss: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
};
